import { createRouter, createWebHistory } from "vue-router";

import { personalSpaceRoutes } from "./module/personal-space";

import { storage } from "@/utils";

const routes = [
  ...personalSpaceRoutes, // 个人空间相关路由
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "LayoutIndex",
    component: () => import("@/layout/index/index.vue"),
    meta: {
      title: "智慧党建培训平台",
    },
    children: [
      {
        path: "",
        name: "LayoutIndexDefault",
        redirect: "/index/home",
      },
      {
        path: "home",
        name: "PageHome",
        component: () => import("@/views/home/home-entry.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "course-learning",
        name: "PageCourseLearning",
        component: () => import("@/views/course-learning/index.vue"),
        meta: {
          title: "课程学习",
        },
      },
      {
        path: "course-learning/:lessonTagId",
        name: "PageCourseLearningLessonId",
        component: () => import("@/views/course-learning/index.vue"),
        meta: {
          title: "课程学习",
        },
      },
      {
        path: "course-learning/:lessonTagId/:lessonId",
        name: "PageCourseLearningLessonIdLesson",
        component: () => import("@/views/course-learning/index.vue"),
        meta: {
          title: "课程列表",
        },
      },
      {
        path: "online-course",
        name: "PageCourseLearningOnline",
        component: () => import("@/views/online-course/index.vue"),
        meta: {
          title: "在线课程自学",
        },
      },
      {
        path: "online-course/:lessonTagId",
        name: "PageCourseLearningOnlineLessonId",
        component: () => import("@/views/online-course/index.vue"),
        meta: {
          title: "课程学习",
        },
      },
      {
        path: "online-course/learn",
        name: "PageCourseLearningOnlineLearn",
        component: () => import("@/views/online-course/index.vue"),
        meta: {
          title: "学习专栏",
        },
      },
      {
        path: "online-course/learn/:learnId",
        name: "PageCourseLearningOnlineLearnLearnDetail",
        component: () => import("@/views/online-course/detail.vue"),
        meta: {
          title: "学习专栏-详情",
        },
      },
      {
        path: "online-course/learn/:learnId/:id",
        name: "PageCourseLearningOnlineReadDetais",
        component: () => import("@/views/online-course/pages/read-details.vue"),
        meta: {
          title: "推荐阅读详情",
        },
        children: [],
      },
      {
        path: "train-activity",
        name: "PageTrainActivity",
        component: () => import("@/views/train-activity/index.vue"),
        meta: {
          title: "集中培训活动",
        },
        children: [],
      },
      {
        path: "exam-center",
        name: "PageExamCenter",
        component: () => import("@/views/exam-center/index.vue"),
        meta: {
          title: "考试中心",
        },
        children: [],
      },
      {
        path: "course-selection-center",
        name: "PageCourseSelectionCenter",
        component: () => import("@/views/course-selection-center/index.vue"),
        meta: {
          title: "选课中心",
        },
      },
      {
        path: "course-selection-center/:lessonTagId",
        name: "PageCourseSelectionCenterLessonTagId",
        component: () => import("@/views/course-selection-center/index.vue"),
        meta: {
          title: "选课",
        },
      },
      {
        path: "readdetais/:lessonTagId/:lessonId/:id",
        name: "PageReadDetais",
        component: () =>
          import("@/views/course-learning/pages/read-details.vue"),
        meta: {
          title: "延伸阅读详情",
        },
        children: [],
      },
      {
        path: "notices",
        name: "PageNoticesList",
        component: () => import("@/views/notices/list.vue"),
        meta: {
          title: "公告列表",
        },
      },
      {
        path: "noticesDetails/:id",
        name: "PageNoticesDetails",
        component: () => import("@/views/notices/detail.vue"),
        meta: {
          title: "公告详情",
        },
      },
      {
        path: "newsDetails/:id",
        name: "PageNewsDetails",
        component: () => import("@/views/news/detail.vue"),
        meta: {
          title: "新闻详情",
        },
      },
      {
        path: "special-training",
        name: "PageSpecialTraining",
        component: () => import("@/views/special-training/list.vue"),
        meta: {
          title: "专题培训",
        },
      },
      {
        path: "party",
        name: "PartyTraining",
        component: () => import("@/views/party-training/list.vue"),
        meta: {
          title: "专题培训",
        },
        redirect: "/index/party/dwzs",
        children: [
          {
            path: "dwxx",
            name: "PageDwxx",
            component: () => import("@/views/party-training/dwStudy.vue"),
            meta: {
              title: "党务学习",
            },
          },
          {
            path: "dwzs",
            name: "PageDwzs",
            component: () => import("@/views/party-training/dwTszs.vue"),
            meta: {
              title: "党务知识",
            },
          },
          {
            path: "tszs",
            name: "PageTszs",
            component: () => import("@/views/party-training/dwZs.vue"),
            meta: {
              title: "他山之石",
            },
          },
          {
            path: "detail/:id",
            name: "PageDwDetail",
            component: () => import("@/views/party-training/detail.vue"),
            meta: {
              title: "他山之石",
            },
          },
          {
            path: "dwyt",
            name: "PageDwyt",
            component: () => import("@/views/party-training/dwYt.vue"),
            meta: {
              title: "党务研讨",
            },
          },
        ],
      },
      {
        path: "special-training/:id",
        name: "PageSpecialTrainingDetail",
        component: () => import("@/views/special-training/detail.vue"),
        meta: {
          title: "专题培训详情",
        },
      },
      {
        path: "special-training/xxzl/:stageId",
        name: "LeaderLearningList",
        component: () =>
          import("@/views/special-training/leader-learning-list.vue"),
        meta: {
          title: "学习资料列表",
        },
      },
      {
        path: "special-training/:id/expert-detail/:expertId",
        name: "PageSpecialTrainingExpertDetail",
        component: () => import("@/views/special-training/expert-detail.vue"),
        meta: {
          title: "专家介绍",
        },
      },
      {
        path: "special-training/:id/notices",
        name: "PageSpecialTrainingNotices",
        component: () => import("@/views/special-training/notice-list.vue"),
        meta: {
          title: "通知列表",
        },
      },

      {
        path: "special-training/:id/notice/:noticeId",
        name: "PageSpecialTrainingNoticeDetail",
        component: () => import("@/views/special-training/notice-detail.vue"),
        meta: {
          title: "通知详情",
        },
      },
      {
        path: "learning-the-way",
        name: "PageLearnigTheWay",
        component: () => import("@/views/learning-the-way/list.vue"),
        meta: {
          title: "学习路上列表",
        },
      },
      {
        path: "my",
        name: "PageMy",
        component: () => import("@/views/my/index.vue"),
        meta: {
          title: "个人中心",
        },
        redirect: "/index/my/profile",
        children: [
          {
            path: "profile",
            name: "PageMyProfile",
            component: () => import("@/views/my/profile/index.vue"),
            meta: {
              title: "个人资料",
            },
          },
          {
            path: "profile-edit",
            name: "PageMyProfileEdit",
            component: () => import("@/views/my/profile-edit/index.vue"),
            meta: {
              title: "修改信息",
            },
          },
          {
            path: "statistics",
            name: "PageMyStatistics",
            component: () => import("@/views/my/statistics/index.vue"),
            meta: {
              title: "学习统计",
            },
          },
          {
            path: "homework",
            name: "PageMyHomework",
            component: () => import("@/views/my/homework/index.vue"),
            meta: {
              title: "我的作业",
            },
          },
          {
            path: "exam",
            name: "PageMyExam",
            component: () => import("@/views/my/exam/index.vue"),
            meta: {
              title: "我的考试",
            },
          },
          {
            path: "report",
            name: "PageMyReport",
            component: () => import("@/views/my/report/index.vue"),
            meta: {
              title: "我的成绩单",
            },
          },
        ],
      },

      // {
      //   path: "training-dues",
      //   name: "TrainingDues",
      //   component: () => import("@/views/training-dues/home/index.vue"),
      //   meta: {
      //     title: "我的党费",
      //   },
      // },
    ],
  },
  {
    path: "/index/videodetails/:id/:lid",
    name: "VideoDetails",
    component: () => import("@/views/course-learning/pages/video-details.vue"),
    meta: {
      title: "课程学习",
    },
    children: [],
  },
  // {
  //   path: "/404",
  //   name: "PageNotFound",
  //   component: () => import("@/views/404/index.vue"),
  //   meta: {
  //     title: "404",
  //   },
  // },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect: "/404",
  // },
];

// 旧首页移除学习路上路由
const appId = storage.get("userInfo")?.appId;
if (appId && appId == 5) {
  (routes[1].children || []).some((item, index) => {
    if (item.name === "PageLearnigTheWay") {
      routes[1].children.splice(index, 1);
      return true;
    }
  });
}

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_BASE_URL_2),
  routes,
});

// 白名单route name，不做任何拦截
const routesWhiteList = ["PageNotFound"];

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (routesWhiteList.includes(to.name)) {
    next();
    return;
  }
  const token = storage.get("token");
  if (!token) {
    // 未登录，跳往另一个项目登录页
    // next();
    window.location.href = `${import.meta.env.VITE_APP_BASE_URL_1}login`;
    return;
  } else {
    const defaultPassword = window.localStorage.getItem("defaultPassword");
    // 初始登录用户强制修改密码
    if (defaultPassword) {
      window.location.href = `${
        import.meta.env.VITE_APP_BASE_URL_1
      }my/change-pwd`;
    } else {
      next();
    }

    const userInfoStr = window.localStorage.getItem("userInfo");
    const userInfoS = JSON.parse(userInfoStr);
    const userInfo = JSON.parse(userInfoS);
    // console.log("userInfo:", userInfo.appId);
    const VITE_PERSONAL_CENTER = `${import.meta.env.VITE_PERSONAL_CENTER}` == "1" ? true: false
    
    if ([1, 2, 3, 4].includes(userInfo.appId) && !VITE_PERSONAL_CENTER) {
      window.location.href = `${import.meta.env.VITE_APP_BASE_URL_1}`;
    }
  }
});

export default router;
